import Butter from 'buttercms'

// Enable preview mode to see all posts regardless of status
const butter = Butter('93116fe880e25e46ca5f84cdfef54a6f83372edd', true)

// Log all API requests
const originalList = butter.post.list
butter.post.list = async function (...args) {
  console.log('=== Butter CMS API Request ===')
  console.log('Arguments:', JSON.stringify(args, null, 2))
  const response = await originalList.apply(this, args)
  console.log('=== Butter CMS API Response ===')
  console.log('Meta:', response.data.meta)
  console.log('Number of posts:', response.data.data.length)
  return response
}

export default butter
